import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import { AppContext, ToastrContext } from '../../contexts';
import styles from './styles.scoped.css';
import FormByRegional from './FormByRegional';
import { submitActivation } from './actions';
import { Radio, Group } from '@mantine/core';
import { FormByRegistrationId } from './FormByRegistrationId';

export function Component() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryScope = searchParams.get('scope');
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const {
    dataSubMerchantActivationSubmit,
    dataEditStatusBySubUserId,
    isLoadingSubMerchantActivationSubmit,
    isLoadingEditStatusBySubUserId,
    messageSubMerchantActivationSubmit,
    messageEditStatusBySubUserId,
  } = useSelector((s) => s.subMerchantActivation);
  const [scope, setScope] = useState(queryScope || '');
  const radioData = [
    { label: 'Semua Data', value: 'byRegional' },
    { label: 'Pilih Pangkalan Tertentu', value: 'byRegistrationId' },
  ];
  const radioStyles = {
    headingLabel: {
      label: {
        fontSize: '15px',
      },
    },
    elRadio: {
      label: {
        fontSize: '13px',
        fontWeight: 'normal',
      },
      inner: {
        display: 'flex',
        alignSelf: 'center',
      },
    },
  };
  const handleChangeScope = (value) => {
    setScope(value);
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('scope', value);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  useEffect(() => {
    setBreadcrumbs(['Aktivasi Fitur Pendaftaran Subpangkalan', 'Ubah Aktivasi']);
  }, []);

  useEffect(() => {
    if (
      (!isLoadingSubMerchantActivationSubmit && dataSubMerchantActivationSubmit) ||
      (!isLoadingEditStatusBySubUserId && dataEditStatusBySubUserId)
    ) {
      setToastr({
        desc: 'Status berhasil diubah',
        type: 'success',
        visible: true,
      });
      !isLoadingSubMerchantActivationSubmit &&
        dataSubMerchantActivationSubmit &&
        navigate(`/registration-activation`);
    } else if (
      (!isLoadingSubMerchantActivationSubmit && messageSubMerchantActivationSubmit) ||
      (!isLoadingEditStatusBySubUserId && messageEditStatusBySubUserId)
    ) {
      setToastr({
        desc: 'Status gagal diubah',
        type: 'danger',
        visible: true,
      });
    }
  }, [
    dataSubMerchantActivationSubmit,
    isLoadingSubMerchantActivationSubmit,
    messageSubMerchantActivationSubmit,
    dataEditStatusBySubUserId,
    isLoadingEditStatusBySubUserId,
    messageEditStatusBySubUserId,
  ]);

  if (messageSubMerchantActivationSubmit) {
    return <ErrorHandler message={messageSubMerchantActivationSubmit} />;
  }

  return (
    <div className={styles.form} style={{ width: '100%' }}>
      <Card className={styles.card}>
        {scope && (
          <>
            <Radio.Group
              label="Aktivasi Fitur Pendaftaran Subpangkalan"
              name="scope"
              onChange={handleChangeScope}
              styles={radioStyles.headingLabel}
              value={scope}
            >
              <Group mt="xs">
                {radioData.map((item, i) => (
                  <Radio
                    key={i}
                    label={item.label}
                    styles={radioStyles.elRadio}
                    value={item.value}
                  />
                ))}
              </Group>
            </Radio.Group>
            <hr className={styles.separator} style={{ margin: '1rem 0' }} />
          </>
        )}
        {scope !== 'byRegistrationId' ? (
          <FormByRegional onSubmit={(values) => dispatch(submitActivation(values))} />
        ) : (
          <FormByRegistrationId />
        )}
      </Card>
    </div>
  );
}

export default Component;
